import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TypeNumber from '../../../form/form-fields/TypeNumber';
import RemoveIcon from '@mui/icons-material/Remove';

export const MatchingPropLeadFieldNumber = ({ property, onChange }) => {
  const { t } = useTranslation();

  const publicLabelField = {
    label: property.label + ` (${t('MIN')})`,
    key: 'minValue',
    unit: property.unit,
    decimalPlaces: property.decimalPlaces ?? 2,
    removeThousandSeparator: !property.thousandSeparator,
  };
  const valueField = {
    label: property.label + ` (${t('MAX')})`,
    key: 'maxValue',
    unit: property.unit,
    decimalPlaces: property.decimalPlaces ?? 2,
    removeThousandSeparator: !property.thousandSeparator,
  };

  function handleUpdate(key, value) {
    const newProp = { ...property, [key]: value };
    onChange(newProp);
  }

  return (
    <Box className="flex items-center gap-1">
      <Box className="w-full">
        <TypeNumber
          size="small"
          field={publicLabelField}
          dataCollection={property}
          updateValidationOnChange={handleUpdate}
        />
      </Box>
      <RemoveIcon />
      <Box className="w-full">
        <TypeNumber
          size="small"
          field={valueField}
          dataCollection={property}
          updateValidationOnChange={handleUpdate}
        />
      </Box>
    </Box>
  );
};
